import { render, staticRenderFns } from "./ListWebserviceIntegracaoView.vue?vue&type=template&id=1625bd22&"
import script from "./ListWebserviceIntegracaoView.vue?vue&type=script&lang=ts&"
export * from "./ListWebserviceIntegracaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports